import clsx from "clsx";
import React, { useCallback, useState } from "react";
import { Popover } from "react-tiny-popover";
import { chatDisconnectMap, UserType } from "../../../../models";
import { useStore } from "../../../../stores";
import { MdSnooze } from "react-icons/md";

type Props = {
  ongoingCall: boolean;
};

export default function DelayDisconnectPopover({ ongoingCall }: Props) {
  const [isDelayPopoverOpen, setIsDelayPopoverOpen] = useState(false);
  const { selectedChat, loadMessages, disconnect } = useStore("chats");
  const { logEvent } = useStore("audit");
  const { user } = useStore("auth");
  const { selectedBot } = useStore("bots");
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = useCallback(
    async (delayedDisconnect: number) => {
      if (!selectedChat) {
        return;
      }

      setIsDelayPopoverOpen(false);
      setIsLoading(true);

      await disconnect(delayedDisconnect);

      let eventName = `agent_will_be_disconnect_after`;

      logEvent(eventName, {
        id: user?.id,
        email: user?.email,
        botId: selectedBot?.id,
        chatId: selectedChat.id,
        after: delayedDisconnect,
      });

      loadMessages(200);

      setIsLoading(false);
    },
    [
      disconnect,
      logEvent,
      loadMessages,
      selectedBot?.id,
      selectedChat,
      user?.email,
      user?.id,
    ]
  );

  const otherAgentConnected =
    user?.type === UserType.Collaborator &&
    !!selectedChat?.userConnected &&
    selectedChat?.userConnected !== user?.id;

  const disabled = ongoingCall || otherAgentConnected;

  return (
    <Popover
      isOpen={isDelayPopoverOpen}
      positions={["top"]}
      containerStyle={{ zIndex: "100000000" }}
      padding={7}
      onClickOutside={() => setIsDelayPopoverOpen(false)}
      content={() => (
        <div className="has-border has-background-white has-rounded-corners">
          {Object.keys(chatDisconnectMap).map((m) => (
            <div
              onClick={() => handleClick(Number(m))}
              className="is-clickable has-border-top py-2 px-5"
            >
              <span className="is-6 mb-0 subtitle">
                {chatDisconnectMap[m as never]}
              </span>
            </div>
          ))}
        </div>
      )}
    >
      <button
        onClick={() => setIsDelayPopoverOpen(true)}
        className={clsx("button is-ghost is-no-box-shadow has-text-primary", {
          "is-loading": isLoading,
        })}
        disabled={disabled}
      >
        {!isLoading && (
          <span className="icon">
            <MdSnooze color="#959595" size={24} />
          </span>
        )}
      </button>
    </Popover>
  );
}
